import { render, staticRenderFns } from "./InvestorsDashboard.vue?vue&type=template&id=26fdaf20&"
import script from "./InvestorsDashboard.vue?vue&type=script&lang=js&"
export * from "./InvestorsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports